import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Collapse,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Link } from 'react-router-dom';

import { userCan } from '../../../helpers/Auth';
import { getSettingsMap } from '../../../helpers/SettingsMap';

const SettingsSidebar = ({
  version,
  openedCollapse,
  handleOpen,
  activeTab,
  toggleNavOpen,
}) => {
  let settingsMap = getSettingsMap();
  if (!userCan('manage_settings') && userCan('add_users')) {
    settingsMap = settingsMap.filter(s => (s.id === 'users-roles-teams'))
      .map(s => ({ ...s, items: s.items.filter(i => (i.id === 'users')) }));
  }

  return (
    <div className="settings-nav-wrapper">
      <div className="settings-nav">
        {settingsMap.map(mainElement => {
          const isOpen = !!openedCollapse[mainElement.id];

          return (
            <Fragment key={mainElement.id}>
              {/* eslint-disable jsx-a11y/click-events-have-key-events  */}
              {/* eslint-disable jsx-a11y/no-static-element-interactions  */}
              <div
                className={classnames(
                  'settings-nav-header',
                  { violet: mainElement.id === 'billing' },
                )}
                onClick={() => handleOpen(mainElement.id)}
              >
                {/* eslint-enable jsx-a11y/click-events-have-key-events  */}
                {/* eslint-enable jsx-a11y/no-static-element-interactions  */}
                <h3>
                  {mainElement.icon && <i className={mainElement.icon} />}
                  {mainElement.label}
                </h3>
                {isOpen ?
                  <i className="fal fa-chevron-up" /> :
                  <i className="fal fa-chevron-down" />}
              </div>
              <Collapse isOpen={isOpen}>
                <Nav vertical>
                  {mainElement.items.map(i => (
                    <NavItem
                      key={i.id}
                    >
                      <NavLink
                        className={classnames({
                          active: activeTab === i.id ||
                          (i.alternativeIds && i.alternativeIds.includes(activeTab)),
                        })}
                        tag={Link}
                        to={`/admin/settings/${i.id}`}
                        onClick={toggleNavOpen}
                      >
                        {i.label}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
              </Collapse>
            </Fragment>
          );
        })}
      </div>
      <p className="stockpress-version">
        {version.version} ({version.gitBranch ? `${version.gitBranch}-` : ''}{version.gitHash})
      </p>
    </div>
  );
};

const mapStateToProps = state => ({
  version: state.App.version,
});

SettingsSidebar.propTypes = {
  version: PropTypes.object.isRequired,
  openedCollapse: PropTypes.object.isRequired,
  handleOpen: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  toggleNavOpen: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(SettingsSidebar);
